import type { WClientTestimonialsTranslations } from "./pl";

export const de: WClientTestimonialsTranslations = {
  defaultTitle: "Kundenmeinungen",
  prev: "Vorherige",
  next: "Nächste",
  goToSlide: "Zur Referenz",
  readRealization: "Projekt ansehen",
};
